// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"118":"component---src-components-templates-page-js","593":"framework"}[chunkId] || chunkId) + "-" + {"118":"bf7b454a330b65f88d08","255":"23785d4c8d6ecbc57cfa","593":"014208b5318c69b76ef4","795":"895290996e6d89010ce9","995":"983bc81f53d6e6a77e3d"}[chunkId] + ".js";
};